var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wp-history-comment-heading" }, [
    _c("strong", { staticClass: "wp-history-comment-heading__title" }, [
      _vm.showIndex ? _c("span", [_vm._v(_vm._s(_vm.index) + ". ")]) : _vm._e(),
      _vm._v(_vm._s(_vm.title) + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "last-update wp-history-comment-heading__byline" },
      [
        _c("div", { staticClass: "last-update__text" }, [
          _vm._v("\n      " + _vm._s(_vm.byline) + "\n    "),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }